export const RunSettlementsRoute = {
  path: '/Accounting/Settlements',
  load: () => import('./RunSettlements'),
  protected: true,
};
